import LockConcentratorManage from '../view/GateLock/GateLockManage/LockConcentratorManage'
import LockConcentratorAdd from '../view/GateLock/GateLockManage/LockConcentratorAdd'
import LockConcentratorModify from '../view/GateLock/GateLockManage/LockConcentratorModify'
import LockGateManage from '../view/GateLock/GateLockManage/LockGateManage'
import LockGateAdd from '../view/GateLock/GateLockManage/LockGateAdd'
import LockGateModify from '../view/GateLock/GateLockManage/LockGateModify'
import LockAuthorizationManage from '../view/GateLock/GateLockAuthorization/LockAuthorizationManage'
import LockAuthorizationAdd from '../view/GateLock/GateLockAuthorization/LockAuthorizationAdd'
import LockAuthorizationRecord from '../view/GateLock/GateLockAuthorization/LockAuthorizationRecord'
import LockIdentificationRecord from '../view/GateLock/LockIdentificationRecord/LockIdentificationRecord'
import LockNav from '../view/GateLock/LockNav'
import Log from '../view/log'

export default [
  {
    path: '/gate_lock/lock_concentrator_manage',
    name: 'lock-concentrator-manage',
    components: {
      default: LockNav,
      a: LockConcentratorManage
    }
  },
  {
    path: '/gate_lock/lock_concentrator_add',
    name: 'lock-concentrator-add',
    components: {
      default: LockNav,
      a: LockConcentratorAdd
    }
  },
  {
    path: '/gate_lock/lock_concentrator_modify/:id',
    name: 'lock-concentrator-modify',
    components: {
      default: LockNav,
      a: LockConcentratorModify
    }
  },
  {
    path: '/gate_lock/lock_gate_manage',
    name: 'lock-gate-manage',
    components: {
      default: LockNav,
      a: LockGateManage
    }
  },
  {
    path: '/gate_lock/lock_gate_add',
    name: 'lock-gate-add',
    components: {
      default: LockNav,
      a: LockGateAdd
    }
  },
  {
    path: '/gate_lock/lock_gate_modify/:id',
    name: 'lock-gate-modify',
    components: {
      default: LockNav,
      a: LockGateModify
    }
  },
  {
    path: '/gate_lock/lock_authorization_manage',
    name: 'lock-authorization-manage',
    components: {
      default: LockNav,
      a: LockAuthorizationManage
    }
  },
  {
    path: '/gate_lock/lock_authorization_add',
    name: 'lock-authorization-add',
    components: {
      default: LockNav,
      a: LockAuthorizationAdd
    }
  },
  {
    path: '/gate_lock/lock_authorization_record',
    name: 'lock-authorization-record',
    components: {
      default: LockNav,
      a: LockAuthorizationRecord
    }
  },
  {
    path: '/gate_lock/lock_identification_record',
    name: 'lock-identification-record',
    components: {
      default: LockNav,
      a: LockIdentificationRecord
    }
  },

  {
    path: '/lock_log',
    name: 'lock-log',
    components: {
      default: LockNav,
      a: Log
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/Lock.js